import { type RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem as MenuItemWithReviewsData, useRootPlaceMenuItemWithReviewsQuery } from '~/libs/gql/queries/root_places/rootPlaceMenuItemWithReviewsQuery.generated';
import { useDishListMenuItemWithReviewsQuery } from '~/libs/gql/queries/dish_lists/dishListMenuItemWithReviewsQuery.generated';

type UseDishListWithReviewsDataArgs = {
  dishListSlug?: string | null | undefined
  limit: number
  menuItemId: number
  offset: number
  placeSlug?: string | null | undefined
}

export const useMenuItemWithReviewsData = ({ dishListSlug, limit, menuItemId, offset, placeSlug }: UseDishListWithReviewsDataArgs) => {
  const placeQuery = useRootPlaceMenuItemWithReviewsQuery({
    skip: !placeSlug,
    variables: {
      approved: true,
      menuItemId,
      pagination: {
        limit,
        offset,
        sortBy: 'createdAt',
        sortDir: 'desc',
      },
      rootPlaceSlug: placeSlug ?? '',
    },
  });
  const listQuery = useDishListMenuItemWithReviewsQuery({
    skip: !dishListSlug,
    variables: {
      approved: true,
      dishListSlug: dishListSlug ?? '',
      menuItemId,
      pagination: {
        limit,
        offset,
        sortBy: 'createdAt',
        sortDir: 'desc',
      },
    },
  });

  const data = placeSlug ? placeQuery.data?.rootPlace : listQuery.data?.dishList;
  const fetchMore = placeSlug ? placeQuery.fetchMore : listQuery.fetchMore;
  const loading = placeSlug ? placeQuery.loading : listQuery.loading;
  return {
    fetchMore,
    loading,
    menuItemData: data?.menuItem as MenuItemWithReviewsData | null,
  };
};
